/* ---------------------------------------------------------------------------
   Whether a road user may cross, as a chip: open, posted at N t, or closed
   (LIFECYCLE.md `LC-23`). The title says who decided and when.

   One drawing, used by the register's row and card, the record, and the map's
   pin, so a posting reads the same wherever it is met. The answer itself is
   `operationalStatus` in src/data/posting.ts.
   --------------------------------------------------------------------------- */

import { tag, type TagRank } from './widgets.ts';
import { decidedLine, operationalStatus, type OperationalFields, type OperationalKind } from '../data/posting.ts';

const RANK: Readonly<Record<OperationalKind, TagRank>> = {
  open: 1,
  posted: 4,
  closed: 4,
  'not-open': 'none',
};

export function statusChip(b: OperationalFields): HTMLSpanElement {
  const status = operationalStatus(b);
  const chip = tag(status.label, RANK[status.kind], `${status.label} — ${decidedLine(status)}`);
  chip.classList.add('tag--status');
  chip.dataset['status'] = status.kind;
  if (status.source !== null) chip.dataset['source'] = status.source;
  return chip;
}
